import axios from 'axios'
import { API_BASE_URL } from '../config';

const RegisterAnswerServices = async (token, formData) => {
    try {
        if (!token) {
            throw new Error('No token available');
        }

        const response = await axios.post(`${API_BASE_URL}userAnswers/`, formData, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        return response.status
    } catch (error) {
        throw Error(error)
    }
}

export default RegisterAnswerServices